import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Paper from '@material-ui/core/Paper';
import Fade from '@material-ui/core/Fade';

const styles = (theme) => ({
    panel: {
        padding: theme.spacing(4),
        [theme.breakpoints.only('xs')]: {
            borderRadius: 0,
        },
    },
});

const Panel = ({ classes, className, children }) => {
    return (
        <Fade in={true}>
            <Paper component="section" className={classNames(classes.panel, className)}>
                {children}
            </Paper>
        </Fade>
    );
};

export default withStyles(styles)(Panel);
